export default function composeId(...args: string[]): string {
    return args.join('.')
}
